import url from 'url';
import { join, getBrandName, isV3 } from '@pes-ui/utils';
import { getNavigationState } from '../../../globals/utils/helpers';
export const getSelectorConfigUrl = (host, rangeId, isHostAbsolutePath) => {
  const localArr = host.split('/');
  const countryCode = localArr[localArr.length - 2];
  const languageCode = localArr[localArr.length - 1];
  const brandName = getBrandName();
  if (isV3()) {
    return `/ranges/${rangeId}/selector-config?country-code=${countryCode}&language-code=${languageCode}&brand=${brandName}`;
  }
  if (isHostAbsolutePath) {
    return `${host}/${join('product/range/selector-config', rangeId)}`;
  }
  return join(host, 'product/range/selector-config', rangeId);
};
export const getFiltersUrl = (host, endpoint, rangeId, navigationState, nodeId, categoryId) => url.format({
  pathname: join(host, endpoint, 'api/range/filters', rangeId, nodeId || '', categoryId || ''),
  query: Object.assign({}, (navigationState.includes('subnode-id')
    ? { 'subnode-id': navigationState.replace('?subnode-id=', '') }
    : { n: getNavigationState(navigationState) })),
});
